import config from 'config';
import Raven from 'libs/Raven';

export function initChargeBeeInstance() {
  window.Chargebee.init({
    site: config.CHARGEBEE.site,
    publishableKey: config.CHARGEBEE.publishableKey,
    enableGATracking: true
  });
}

export function getChargeBeeInstance() {
  if (window.Chargebee.inited) {
    return window.Chargebee.getInstance();
  }
  return {};
}

function closeChargeBeeModal(cbInstance = {}) {
  if (cbInstance.closeAll) {
    cbInstance.closeAll();
  }
}

export function logoutChargeBee() {
  const chargeBeeInstance = getChargeBeeInstance();
  closeChargeBeeModal(chargeBeeInstance);
  if (chargeBeeInstance.logout) {
    chargeBeeInstance.logout();
  }
}

export const CHARGEBEE_INIT = 'CHARGEBEE_INIT';
export const CHARGEBEE_LOGOUT = 'CHARGEBEE_LOGOUT';
export const CHARGEBEE_GET_INSTANCE = 'CHARGEBEE_GET_INSTANCE';
export const CHARGEBEE_CLOSE_MODAL = 'CHARGEBEE_CLOSE_MODAL';

const chargeBeeActionMap = {
  [CHARGEBEE_INIT]: initChargeBeeInstance,
  [CHARGEBEE_LOGOUT]: logoutChargeBee,
  [CHARGEBEE_GET_INSTANCE]: getChargeBeeInstance,
  [CHARGEBEE_CLOSE_MODAL]: closeChargeBeeModal
};

export default function chargeBeeAction(type, param) {
  try {
    return chargeBeeActionMap[type] && chargeBeeActionMap[type](param);
  } catch (error) {
    Raven.captureException(error);
  }
  return false;
}



// WEBPACK FOOTER //
// ./src/libs/chargeBee.js